import { render, staticRenderFns } from "./MobileEdit.vue?vue&type=template&id=3c5931b4&scoped=true"
import script from "./MobileEdit.vue?vue&type=script&lang=js"
export * from "./MobileEdit.vue?vue&type=script&lang=js"
import style0 from "./MobileEdit.vue?vue&type=style&index=0&id=3c5931b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5931b4",
  null
  
)

export default component.exports